import { Component, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { NgbPopover, NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sm-input',
    templateUrl: './sm-input.component.html',
    styleUrls: ['./sm-input.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmInputComponent),
            multi: true
        }
    ]
})
export class SmInputComponent extends SmUiComponent implements OnInit  {
    @Input() override props: any;
    showPassword: boolean = false;
    originalPlaceholder: string;
    @Output() InputAction = new EventEmitter<any>();
    @ViewChild('popoverRef', { static: false }) popover: NgbPopover;
    override ngOnInit(): void {
        super.ngOnInit();
        this.originalPlaceholder = this.props.placeholder;
    }
  

    toggleShowPassword(): void {
        if (this.props.propShowPassword === true) {
            this.showPassword = !this.showPassword;
            this.props.proptype = this.showPassword ? 'text' : 'password';
        }
    }

    onIconClick() {
        if (this.popover) {
          if (this.popover.isOpen()) {
            this.popover.close();
          } else {
            this.popover.open();
          }
        } else {
          console.error('Popover reference is not defined');
        }
      }

    performInputAction(): void {
        this.InputAction.emit(true);
    }
}
